import imageOne from './AboutContent/5.png';
import imageTwo from './AboutContent/6.png';
import imageThree from './AboutContent/7.png';
import imageFour from './AboutContent/8.png';

export const dataAbout = [
  {
      id: 0,
      image: imageOne,
      textOne: "VISIT US",
      textTwo: "find our cafe",
      textThree: "We purchase the best coffee beans all over the world"
  },

  {
      id: 1,
      image: imageTwo,
      textOne: "TAKEAWAY",
      textTwo: "taste coffee every day",
      textThree: "Take coffee with you on the road"
  },

  {
      id: 2,
      image: imageThree,
      textOne: "MASTERCLASSES",
      textTwo: "book a class",
      textThree: "Events take place throughout the day without a break"

  },

  {
      id: 3,
      image: imageFour,
      textOne: "BREWING",
      textTwo: "view the recipes",
      textThree: "A brewed drink prepared from roasted beans is coffee"
  }
]
